import mapboxgl from 'mapbox-gl';
import * as m from "./mapInit";
import $ from "jquery";

//--------------------------------------------------------------
//------------------------------------------------------------------------
//CREATE BUTTONS
//------------------------------------------------------------------------

let links = $('.layer-toggle');
let dropdownToggle = $('.dropdown-toggle');
let legends = $('.legend');
let legendList = $('.legend-list');

// dropdownToggle.append('<div className="icon-open"></div>');
let showLegend = function(event, i){
  legends.hide();
  $('.legend').eq(i).show();
};

links.each(function(i, link){
  let id = m.toggleableLayerIds[i];

  // let name = m.toggleableLayerNames2[i];
  link.onclick = function (e) {
    let popups = $('.mapboxgl-popup.big');
    popups.remove();
    showLegend(e, i);
    m.hideAllLayers();
    let clickedLayer = this.id;
    e.preventDefault();
    //e.stopPropagation();

    let visibility = m.map.getLayoutProperty(clickedLayer, 'visibility');

    if (visibility === 'visible') {
      m.map.setLayoutProperty(clickedLayer, 'visibility', 'none');
      this.className = '';
    } else {
      this.className = 'active';
      m.map.setLayoutProperty(clickedLayer, 'visibility', 'visible');
      m.map.setLayoutProperty('nuts0-outline', 'visibility', 'visible');
      m.map.setLayoutProperty('nuts3-outline', 'visibility', 'visible');
      m.map.setLayoutProperty('NODATA', 'visibility', 'visible');
    }
  };
  
});